define('bindingHandlers/notFeatureToggle',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'services/featureToggleService'
], function($, ko, _, featureToggleService) {
    'use strict';

    /**
     * A binding handler for including a section of markup in the document (
     * and to have its data-bind attributes applied), only if a specified feature flag is NOT enabled.
     *
     * # Required arguments
     *
     * @param {String} value - The name of the feature flag that should be checked
     *
     * # Example
     *
     * <!-- ko notFeatureToggle: 'conferencing' -->
     *     <div></div>
     * <!-- /ko -->
     *
     */
    ko.bindingHandlers.notFeatureToggle = {

        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            // Initially hide everything to not show hidden features for a little bit before the feature toggles are
            // fetched for the first time.
            var feature = ko.unwrap(valueAccessor()),
                enabled = featureToggleService.getFeatureToggle(feature);

            ko.bindingHandlers.ifnot.init(element, enabled, allBindings, viewModel, bindingContext);

            // Prevent inner bindings from being bound twice
            return { controlsDescendantBindings: true };
        }
    };

    ko.virtualElements.allowedBindings.notFeatureToggle = true;
});

